import React from 'react';
import useAppContext from 'flow/hooks/useAppContext';
import { useAppDispatch, useAppSelector } from 'flow/hooks/useRedux';
import { toggleLobbyAudioActive } from 'flow/actions/meeting-lobby-actions';
import MeetingLobbyDeviceButton from './MeetingLobbyDeviceButton';

/**
 * Mute and unmute before joining. Reads as off both when muted and when the
 * browser refused the microphone — in either case nothing is being picked up,
 * which is what the control is telling you.
 */
const MeetingLobbyMicButton = () => {
    const { i18next } = useAppContext();
    const dispatch = useAppDispatch();

    const audioActive = useAppSelector((state) =>
        state.meeting.getIn(['lobby', 'audioActive']),
    );
    const micAllowed = useAppSelector((state) =>
        state.meeting.getIn(['devices', 'micAllowed']),
    );

    const micIsOn = audioActive && micAllowed;

    return (
        <MeetingLobbyDeviceButton
            dataTestId="meeting-lobby-mic-button"
            iconKey={micIsOn ? 'mic_outlined' : 'mic_off'}
            isOn={micIsOn}
            disabled={!micAllowed}
            // Names what pressing it does, as the meeting's does. No keyboard
            // shortcut appended: those are bound in MeetingFooter and toggle the
            // meeting's sender, so they do not reach the lobby.
            tooltipLabel={i18next.t(
                micIsOn
                    ? 'videoconference.controlpanel.turn_mic_off'
                    : 'videoconference.controlpanel.turn_mic_on',
            )}
            onClick={() => dispatch(toggleLobbyAudioActive())}
        />
    );
};

export default MeetingLobbyMicButton;
